export const useScrollState = () => {
  const scrolled = useState('scrolled', () => false)
  const scrollY = useState('scrollY', () => 0)
  const scrollBottom = useState('scrollBottom', () => 1000)

  return {
    scrolled,
    scrollY,
    scrollBottom
  }
}
